import React, { useRef, useState, useEffect } from "react";
import {
  Card,
  Divider,
  TextField,
  Typography,
  Tooltip,
  makeStyles
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import penImg from "../../../assets/icons/pen.png";
import trashImg from "../../../assets/icons/trash.png";
import AlertDialog from "../../../components/AlertDialog.js";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  listItem: {
    backgroundColor: "#f6fafe",
    paddingLeft: 5,
    borderRadius: 8,
    marginBottom: 10,
  },
  textFieldStyle: {
    "& .MuiInput-root": {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  iconActiveStyle: {
    cursor: "pointer",
    height: 24,
  },
  iconInActiveStyle: {
    cursor: "pointer",
    height: 24,
    pointerEvents: "none",
  }
}))

const DropDown = ({ handleChangeSelect,
                    // selVal,
                    selOpts,
                    setAutoCompleteValue,
                    removeFromAutoComplete,
                    passEditedValue }) => {

  // const [selectValue, setSelectValue] = useState(
  //   selVal ?
  //   selVal === 'Select' ?
  //   "Configure Option"
  //   :
  //   selVal
  //   : 'Select'
  // );
  const [selectedOptions, setSelectedOptions] = useState(selOpts ? selOpts : []);
  const [confInputValue, setConfInputValue] = useState('');
  const [oldValue, setOldValue] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [editState, setEditState] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);
  const [open, setOpen] = useState(true);

  const classes = useStyles();
  let addInput = useRef(null);
  let listItemInput = useRef(null);

  useEffect(() => {
    handleChangeSelect(
      "Select",
      selectedOptions ? selectedOptions : []
    );
  }, [selectedOptions]);

  // useEffect(() => {
  //   if (selectValue === "Configure Option") addInput.current.focus();
  // }, [selectValue]);

  //Adding editable flag to every value of builtInOptions
  // const updBuiltInOps = builtInOptions.map((entry) => ({
  //   ...entry,
  //   values: entry.values.map((value) => ({
  //     title: value,
  //     editable: false
  //   }))}
  // ));

  const handleClose = () => {
    setOpen(false);
  };

  // const handleChange = (e) => {
  //   setSelectValue(e.target.value);
  //   setAutoCompleteValue(null);
  //   let foundSelect = updBuiltInOps.find((item) => {
  //     return item.name === e.target.value;
  //   })
  //   if (foundSelect) setSelectedOptions(foundSelect.values);
  //   else setSelectedOptions([]);
  // };

  const handleDeleteOption = (opt) => {
    removeFromAutoComplete(opt);
    let foundItem = selectedOptions.find((item) => {
      return item.title === opt.title;
    });
    if (foundItem) {
      let filteredData = selectedOptions.filter(
        item => item.title !== foundItem.title
      );
      if (filteredData) setSelectedOptions(filteredData);
    };
    addInput.current && addInput.current.focus();
  };

  const toggleEditFlag = (opt, editMode) => {
    editMode && setCurrentValue(opt.title);
    setEditState(editMode);
    setOldValue(opt.title);
    const chgOptProps = findAnd.changeProps(
      selectedOptions,
      { title: opt.title },
      {
        editable: !opt.editable
      }
    );
    setSelectedOptions(chgOptProps);
  };

  const handleAddOption = () => {

    // If option label is empty, do nothing
    if (confInputValue.trim() === "") {
      addInput.current.focus();
      return
    };

    // If option label is repeated, display an alert modal
    if (selectedOptions.find(
      item => item.title === confInputValue.trim()
      ))
    {
      setAlertMsg({
        title: "Option Label Validation",
        msg:
          "Option label already exists. Please input a different label.",
      });
      addInput.current.focus();
      return
    };

    setSelectedOptions(
      [...selectedOptions,
        {title:confInputValue.trim(), editable: false}
      ]
    );
    setConfInputValue('');
    addInput.current && addInput.current.focus();
  };

  const handleUpdateOpt = (index) => {

    // If option label is empty, do nothing
    if (currentValue.trim() === "") {
      listItemInput.current.focus();
      return
    };

    // If option label is repeated, display an alert modal
    if (selectedOptions.find(
      item => item.title === currentValue.trim()
      ) && currentValue.trim() !== oldValue)
    {
      setAlertMsg({
        title: "Option Label Validation",
        msg:
          "Option label already exists. Please input a different label.",
      });
      listItemInput.current.focus();
      return
    };
    let newOption = {title:currentValue, editable: true};
    selectedOptions.splice(index, 1, newOption);
    passEditedValue(newOption, oldValue);
    setSelectedOptions(selectedOptions);
    toggleEditFlag(newOption, false);
    addInput.current && addInput.current.focus();
  };

  const handleCancelEdit = (option) => {
    setEditState(false);
    let chgOptProps = [];
    if (oldValue === option.title) {
      chgOptProps = findAnd.changeProps(
        selectedOptions,
        { title: option.title },
        {
          editable: false,
        }
      );
    }
    else
    {
      chgOptProps = findAnd.changeProps(
        selectedOptions,
        { title: currentValue },
        {
          title:oldValue,
          editable: false,
        }
      );
    };
    setSelectedOptions(chgOptProps);
    setOldValue("");
    addInput.current && addInput.current.focus();
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>        
        <Box mt={1}>
          <TextField
            inputRef={addInput}
            id="textField"
            variant="outlined"
            fullWidth
            placeholder="Enter Option Label"
            value={confInputValue}            
            onChange={e => setConfInputValue(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <StyledTooltip title="Add">
                    <IconButton edge="end"
                      disabled= {confInputValue === ''}
                      onClick={() => handleAddOption()}
                    >
                      <AddIcon />
                    </IconButton>
                  </StyledTooltip>
                </InputAdornment>
              ),
            }}
            onKeyPress={ev => {
              if (ev.key === "Enter") {
                handleAddOption();
                addInput.current.focus();
              }
            }}
          />
        </Box>        
        <Box mt={1}>
          <Card variant="outlined"
            style={{ maxHeight: "177px", overflowY: "scroll" }}
          >
            <List>
              <Box
                pl={1}
                pr={1}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {selectedOptions.map((option, i) => (
                  <ListItem
                    key={i}
                    className={classes.listItem}
                    secondaryAction={
                    <>
                      {!option.editable ? (
                        <Box>
                          <StyledTooltip title="Edit">
                            <img
                              className={ editState ? classes.iconInActiveStyle
                                                    : classes.iconActiveStyle }
                              src={penImg}
                              onClick={() => toggleEditFlag(option, true)}
                            />
                          </StyledTooltip>
                          <StyledTooltip title="Delete">
                            <img
                              style={{
                                marginLeft: 15,
                              }}
                              className={ editState ? classes.iconInActiveStyle
                                                    : classes.iconActiveStyle }
                              src={trashImg}
                              onClick={() => handleDeleteOption(option)}
                            />
                          </StyledTooltip>
                        </Box>
                      ) : (
                        <Box>
                          <StyledTooltip title="Save">
                            <IconButton
                              onClick={() => {
                                handleUpdateOpt(i);
                              }}
                            >
                              <DoneIcon />
                            </IconButton>
                          </StyledTooltip>
                          <StyledTooltip title="Cancel">
                            <IconButton
                              onClick={() => handleCancelEdit(option)}
                            >
                              <CloseIcon />
                            </IconButton>
                          </StyledTooltip>
                        </Box>
                      )}
                    </>
                  }
                  >
                    {!option.editable ? (
                      <Box style={{width: 180}}>
                        <Typography
                          style={{  fontSize: 14,
                                    fontWeight: 400,
                                    wordWrap: 'break-word' }}
                        >
                          {option.title}
                        </Typography>
                      </Box>
                    ) : (
                      <Box style={{width: 180}}>
                        <TextField
                          style={{wordWrap: 'break-word' }}
                          inputRef={listItemInput}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          autoFocus
                          variant="standard"
                          defaultValue={option.title}
                          className={classes.textFieldStyle}
                          fullWidth
                          onChange={event => setCurrentValue(event.target.value)}
                          onKeyPress={ev => {
                            if (ev.key === "Enter") {
                              setCurrentValue(ev.target.value)
                              handleUpdateOpt(i);
                            }
                          }}
                        />
                      </Box>
                    )}
                  </ListItem>
                ))}
              </Box>
            </List>
          </Card>
        </Box>
        {alertMsg.msg && (
          <AlertDialog
            title={alertMsg.title}
            type={alertMsg.type}
            contentMsg={alertMsg.msg}
            closeDialog={() => setAlertMsg([])}
            cancelSaveAction={() => {
              setAlertMsg([]);
              handleClose();
            }}
          />
        )}
      </FormControl>
    </Box>
  );
};
export default DropDown;
